export const ServiceStatus = {
    UNKNOWN: 0,
    ACTIVE: 1,
    INACTIVE: 2,
    ENABLED: 4,
    DISABLED: 8,
};

export const Actions = {
    CREATE: 'action.create',
    VERIFY: 'action.verify',
    UPDATE: 'action.update',
    CLOSE: 'action.close',
    REMOVE: 'action.remove',
    REMOVE_CONFIRMED: 'action.remove.confirm',
};

export const Shedule = {
    FREQUENCY: 'Daily',
    TIME: 0,
    DAY: 'Monday',
    TIMEZONE: 'Europe/London',
    FREQUENCIES: {
        Daily: 'Daily',
        Weekly: 'Weekly',
    },
    DAYS: {
        Monday: 'Monday',
        Tuesday: 'Tuesday',
        Wednesday: 'Wednesday',
        Thursday: 'Thursday',
        Friday: 'Friday',
        Saturday: 'Saturday',
        Sunday: 'Sunday',
    },
    isWeekly(value) {
        return value === 'Weekly';
    },
};
